import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminMicrosoftTeamsComponent } from './admin-microsoft-teams.component';

const routes: Routes = [
  {
    path: '',
    component: AdminMicrosoftTeamsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminMicrosoftTeamsRoutingModule {}
